





















import Vue from 'vue';
import { mapGetters } from 'vuex';
import i18n from '@/web/utils/localization';
import SidebarNavItem from '@/web/components/navigation/SidebarNavItem.vue';

const shareLinks = [
  {
    name: 'Facebook',
    icon: 'fab fa-facebook',
    getLink(url) {
      return `https://www.facebook.com/sharer.php?${encodeURIComponent(url)}`;
    },
  },
  {
    name: 'Linkedin',
    icon: 'fab fa-linkedin',
    getLink(url) {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    },
  },
  {
    name: 'Twitter',
    icon: 'fab fa-twitter',
    getLink(url) {
      const text = i18n.t('BIO.TEXT.MY_MARVELOUS_BIO_HAS_SOME', { url });
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text
      )}`;
    },
  },
  {
    name: 'Whatsapp',
    icon: 'fab fa-whatsapp',
    getLink(url) {
      const text = i18n.t('BIO.TEXT.MY_MARVELOUS_BIO_HAS_SOME', { url });
      return `https://api.whatsapp.com/send/?phone&text=${text}&app_absent=0`;
    },
  },
  {
    name: 'Messenger',
    icon: 'fab fa-facebook-messenger',
    getLink() {
      return 'https://www.messenger.com/new';
    },
  },
  {
    name: 'Email',
    icon: 'far fa-envelope',
    getLink(url) {
      const subject = url;
      const body = i18n.t('BIO.TEXT.MY_MARVELOUS_BIO_HAS_SOME', { url });

      return `mailto:?body=${body}&subject=${subject}`;
    },
  },
];

export default Vue.extend({
  name: 'bio-share-modal',
  components: {
    SidebarNavItem,
  },
  data() {
    return {
      shareLinks,
    };
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
    bioLink() {
      const hostName =
        process.env.VUE_APP_MARVELOUS_BIO_URL || 'https://marvelous.bio';
      const link = `${hostName}/${this.teacher.studio_url}`;
      return link;
    },
  },
  methods: {
    copy(): void {
      this.$copyText(this.bioLink).then(() => {
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('BIO.TEXT.MARVELOUS_BIO_LINK_COPIED_TO_CLIPBOARD'),
        });
      });
    },
    openShareLink(shareLink) {
      window.open(shareLink.getLink(this.bioLink), '_blank');
    },
  },
});
